import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { productService } from '../services/productService';
import { productUrl } from '../utils/seo';

/**
 * Redirects legacy /products/:id URLs to the new SEO-friendly /producto/:slug format.
 */
function ProductRedirect() {
  const { id } = useParams();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    productService.getById(id)
      .then((res) => setTarget(productUrl(res.data)))
      .catch(() => setTarget('/'));
  }, [id]);

  if (!target) return null;
  return <Navigate to={target} replace />;
}

export default ProductRedirect;
